equalheight = function(container){

var currentTallest = 0,
     currentRowStart = 0,
     rowDivs = new Array(),
     $el,
     topPosition = 0;
 $(container).each(function() {

   $el = $(this);
   $($el).height('auto')
   topPostion = $el.position().top;

   if (currentRowStart != topPostion) {
     for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
       rowDivs[currentDiv].height(currentTallest);
     }
     rowDivs.length = 0; // empty the array
     currentRowStart = topPostion;
     currentTallest = $el.height();
     rowDivs.push($el);
   } else {
     rowDivs.push($el);
     currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
  }
   for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
     rowDivs[currentDiv].height(currentTallest);
   }
 });
}

$(document).ready(function() {
    var getRating = $('.review-point li a.active').length;
    $('input[name="ratings"]').val(getRating);

    $('.review-point li a').click(function() {
        $(this).parents('li').nextAll().find('a').removeClass('active');
        $(this).parents('li').prevAll().find('a').addClass('active');
        $(this).addClass('active');
        var getRating = $('.review-point li a.active').length;
        $('input[name="ratings"]').val(getRating);
    });

    $('.submit-btn').click(function(e) {
        var userinput = $('.question-wrap input[type="email"]').val();
        var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!pattern.test(userinput)) {
            alert('not a valid e-mail address');
        } else {
            var form = $('#review-form')[0];
            var formData = new FormData(form);
            var username = "client";
            var password = "sand@solution";
            $.ajax({
                type: "POST",
                url: 'https://digitalparcdemo.com/girlsweekend/public_review/postreview/',
                data: formData,
                crossDomain: true,
                contentType: false,
                processData: false,
                success: function(response) {
                    window.location.href = '/pages/reviews'
                }
            });

        }

    });
  
  $('.subscribe-submit-btn').click(function(){
	var email = $('.input-box').val();
  	$('.mail-chimp-form .email').val(email);
    
    $('.mail-chimp-form input[name="subscribe"]').trigger('click');
    $('.close-btn').trigger('click');
  });
  
  

//     $('input[name="recommend"]').change(function() {
//         var recommand = $(this).val();
//         if (recommand == 1) {
//             $('.dislike').find('input').attr('disabled', 'disabled');
//             $('.like').find('input').removeAttr('disabled', 'disabled');
//         } else {
//             $('.like').find('input').attr('disabled', 'disabled');
//             $('.dislike').find('input').removeAttr('disabled', 'disabled');
//         }
//     });
  
  $('.close-btn').click(function(){
  	$(this).parents('.blog-post-popup').removeClass('show-popup');
  })
  
  equalheight('body .custom-blog-pagination .blog__article .blog__infos h3');
  $(document).on('click','.custom-blog-pagination ul.pagination li a', function(){
    setTimeout(function(){ 
      equalheight('body .custom-blog-pagination .blog__article .blog__infos h3');
    }, 1000);
    
  });

  
  
  var paginationLength = $('.custom-pagination .pf-cmIpgn a').length;
  $('.pagination').append('<li class="prev"><a href="javascript:void(0)"> < </a>');
  for (i = 1; i <= paginationLength; i++) {
    $('.pagination').append('<li class="pageNumber"><a href="javascript:void(0)">'+i+'</a></li>')
  }
  $('.pagination').append('<li  class="next"><a href="javascript:void(0)"> > </a>');
  $('.pageNumber').eq(0).addClass('active');
  $('.pagination .prev').css('display','none');

  $('.pagination .pageNumber a').click(function(){ 
    var selectedVal = $(this).text();
    
    $('.pagination li').removeClass('active');
    $(this).parents('li').addClass('active');
	var triggerVal = $(this).parents('.custom-blog-pagination').find('.pf-cmIpgn a[href="?page='+selectedVal+'"]');
	triggerVal[0].click();
    if($('li.pageNumber.active').index() == paginationLength)
    {
      $('.pagination .next').css('display','none');
      $('.pagination .prev').css('display','block');
    }
    else if($('li.pageNumber.active').index() == 1)
    {
      $('.pagination .prev').css('display','none');
      $('.pagination .next').css('display','block');
    }
  });
  
  $('.pagination .next').click(function(e){
    e.preventDefault();
    $(this).parent('.pagination').find('li.active').next().addClass('active');
    $(this).parent('.pagination').find('li.active').prev().removeClass('active');
    var selectedVal = $(this).parent('.pagination').find('li.active').text();
    var triggerVal = $(this).parents('.custom-blog-pagination').find('.pf-cmIpgn a[href="?page='+selectedVal+'"]');
    triggerVal[0].click();
    $('.pagination .prev').css('display','block')
    if($(this).parent('.pagination').find('li.pageNumber.active').index() == paginationLength)
    {
      $(this).css('display','none');
    }
    
//     $(this).parent('.pagination').find('li:hidden').css('display','block');
//     $(this).parent('.pagination').find('li:visible').css('display','none'); 	
  })
  $('.pagination .prev').click(function(e){
    e.preventDefault();
    $('.pagination .next').css('display','block');
    $(this).parent('.pagination').find('li.active').prev().addClass('active');
    $(this).parent('.pagination').find('li.active').next().removeClass('active');
    var selectedVal = $(this).parent('.pagination').find('li.active').text();
    var triggerVal = $(this).parents('.custom-blog-pagination').find('.pf-cmIpgn a[href="?page='+selectedVal+'"]');
    triggerVal[0].click();
    if($(this).parent('.pagination').find('li.pageNumber.active').index() == 1)
    {
      $(this).css('display','none');
    }
//     $(this).parent('.pagination').find('li:hidden').css('display','block');
//     $(this).parent('.pagination').find('li:visible').css('display','none'); 	
  })
});

  $(window).load(function() {
    equalheight('body .custom-blog-pagination .blog__article .blog__infos h3');
      var getreviewLength = $('.review-section').length;
            var globUrl = 'https://digitalparcdemo.com/girlsweekend/';
            var username = "client";
            var password = "sand@solution";
      if (getreviewLength) {
          $.ajax({
              type: "get",
              url: globUrl + 'public_review/listreview/',
              crossDomain: true,
              success: function(response) {
                  var html = '';
                  var reviews = JSON.parse(response);
                  $.each(reviews, function(i, v) {
                      var review = reviews[i];
                      var place_name = (review.place_name) ? review.place_name : '';
                      var place_venue = (review.place_venue) ? review.place_venue : '';
                      var place_address = (review.place_address) ? review.place_address : '';
                      var ratings = (review.ratings) ? review.ratings : '';
                      var review_disc = (review.like_desc) ? review.like_desc : review.dislike_desc;
                      var email = (review.email) ? review.email : '';
                      var friends_count = (review.friends_count) ? review.friends_count : '';
                      var recipes_suggestion = (review.recipes_suggestion) ? review.recipes_suggestion : '';
                      var location_suggestion = (review.location_suggestion) ? review.location_suggestion : '';
                      var images = (review.images) ? review.images : '';
                      var insta_handle = (review.insta_handle) ? review.insta_handle : '';
                      var fb_handle = (review.fb_handle) ? review.fb_handle : '';
                      var twitter_handle = (review.twitter_handle) ? review.twitter_handle : '';
                      var like_desc = (review.like_desc) ? review.like_desc : '';
                      var dislike_desc = (review.dislike_desc) ? review.dislike_desc : '';
                      var reach_type = (review.reach_type) ? review.reach_type : '';
                      var name = (review.name) ? review.name : '';
                      var recommend = (review.recommend == '1') ? 'yes' : 'no';
                      var recommand_text = (review.recommend == '1') ? 'Liked' : 'Disliked';

                      html += '<div class="review-detail">';
                      html += '<div class="image-box">';
                      html += '<img src="' + globUrl + images + '">';
                      html += '</div>';
                      html += '<div class="content-box">';
                      html += '<div class="header-title">';
                      html += '<p>' + place_name + ' in ' + place_address + '</p>';
                      html += '<div class="review-point">';
                      html += '<ul>';
                      for (var e = 1; e < 6; e++) {
                          if (e <= ratings) {
                              html += '<li>';
                            html += '<a href="javascript:void(0);" class="active">';
                              html += '<img src="https://cdn.shopify.com/s/files/1/0274/5522/5927/files/hart-icon.png?v=1597909200">';
                              html += '<img src="https://cdn.shopify.com/s/files/1/0274/5522/5927/files/hart-icon-hover.png?v=1597909200">';
                              html += '</a>';
                              html += '</li>';
                          } else {
                              html += '<li>';
                            html += '<a href="javascript:void(0);">';
                              html += '<img src="https://cdn.shopify.com/s/files/1/0274/5522/5927/files/hart-icon.png?v=1597909200">';
                              html += '<img src="https://cdn.shopify.com/s/files/1/0274/5522/5927/files/hart-icon-hover.png?v=1597909200">';
                              html += '</a>';
                              html += '</li>';

                          }
                      }
                      html += '</ul>';
                      html += '</div>';
                      html += '</div>';
                      html += '<p>' + review_disc + '</p>';
                      html += '<div class="review-btn-social-wrap">';
                      html += '<a href="#selectableModal' + i + '" data-fancybox class="read-more-btn">Read More</a>';
                      html +='<ul>';
                      html +='<li class="review-scoial-title">Share:</li>';
                      html +='<li><a target="_blank" href="//www.facebook.com/sharer/sharer.php?u=https://girlsweekendblog.com/&title=review&description='+review_disc+'"><i class="fa fa-facebook"></i></a></li>';
                      html +='<li><a target="_blank" href="//twitter.com/intent/tweet?source=https://girlsweekendblog.com/&text='+review_disc+' - https://girlsweekendblog.com/"><i class="fa fa-twitter"></i></a></li>';
                      html +='</ul>';
                      html += '</div>';
                      html += '<div style="display: none;" id="selectableModal' + i + '" class="review-detail-popup">';
                      html += '<div class="image-box">';
                      html += '<img src="' + globUrl + images + '">';
                      html += '</div>';
                      html += '<div class="popup-detail">';
                      html += '<div class="question-wrap">';
                      html += '<p class="title">Where did you go?</p>';
                      html += '<p>' + place_name + '</p>';
                      html += '</div>';
                      html += '<div class="question-wrap">';
                      html += '<p class="title">Business or venue names</p>';
                      html += '<p>' + place_venue + '</p>';
                      html += '</div>';
                      html += '<div class="question-wrap">';
                      html += '<p class="title">where was it?</p>';
                      html += '<p>' + place_address + '</p>';
                      html += '</div>';
                      html += '<div class="question-wrap">';
                      html += '<p class="title">How many girlfriends were with you?</p>';
                      html += '<p>' + friends_count + '</p>';
                      html += '</div>';
                    if(recipes_suggestion){
                      html += '<div class="question-wrap">';
                      html += '<p class="title">Did you use one of our recipes or go to one of our suggested restaurants from our "Lets Eat" blog?</p>';
                      html += '<p>' + recipes_suggestion + '</p>';
                      html += '</div>';
                    }
                    if(location_suggestion){
                      html += '<div class="question-wrap">';
                      html += '<p class="title">Did you go to a suggested location from our "Lets Go" blog?</p>';
                      html += '<p>' + location_suggestion + '</p>';
                      html += '</div>';
                    }
                      html += '<div class="question-wrap">';
                      html += '<p class="title">How did you get there?</p>';
                      html += '<p>' + reach_type + '</p>';
                      html += '</div>';
                      html += '<div class="question-wrap">';
                      html += '<p class="title">Would you recommend it to others?</p>';
                      html += '<p>' + recommend + '</p>';
                      html += '</div>';
                    if(like_desc){
                      html += '<div class="question-wrap">';
                      html += '<p class="title">What is one thing you liked?</p>';
                      html += '<p>' + like_desc + '</p>';
                      html += '</div>';
                    }
                      if(dislike_desc){
                      html += '<div class="question-wrap">';
                      html += '<p class="title">What is one thing you disliked?</p>';
                      html += '<p>' + dislike_desc + '</p>';
                      html += '</div>';
                      }
                      html += '<div class="question-wrap">';
                      html += '<p class="title">Overall, how much love would you give your experience?</p>';
                      html += '<div class="review-point">';
                      html += '<ul>';
                      for (var j = 1; j < 6; j++) {
                          if (j <= ratings) {
                              html += '<li>';
                              html += '<a href="javascript:void(0);" class="active">';
                              html += '<img src="https://cdn.shopify.com/s/files/1/0274/5522/5927/files/hart-icon.png?v=1597909200">';
                              html += '<img src="https://cdn.shopify.com/s/files/1/0274/5522/5927/files/hart-icon-hover.png?v=1597909200">';
                              html += '</a>';
                              html += '</li>';
                          } else {
                              html += '<li>';
                              html += '<a href="javascript:void(0);">';
                              html += '<img src="https://cdn.shopify.com/s/files/1/0274/5522/5927/files/hart-icon.png?v=1597909200">';
                              html += '<img src="https://cdn.shopify.com/s/files/1/0274/5522/5927/files/hart-icon-hover.png?v=1597909200">';
                              html += '</a>';
                              html += '</li>';
                          }
                      }
                      html += '</ul>';
                      html += '</div>';
                      html += '</div>';
                      html += '<div class="question-wrap">';
                      html += '<p class="title">Care to share…</p>';
                      if(insta_handle){
                        html += '<p>Instagram: ' + insta_handle + '</p>';
                      }
                      if(fb_handle){
                        html += '<p>Facebook: ' + fb_handle + '</p>';
                      }
                      if(twitter_handle){
                        html += '<p>Twitter: ' + twitter_handle + '</p>';
                      }
                      html += '<p>' + name + '</p>';
                      html += '<p>' + email + '</p>';
                      html += '</div>';
                      html += '<a href="" data-fancybox-close class="close-btn">close</a>';
                      html += '</div>';
                      html += '</div>';
                      html += '</div>';
                      html += '</div>';
                  });

                  $('.review-append').append(html);
              }
          });
      }

	
      var getcookie = getCookie('popup-newsletter');	
    	if(!getcookie){
        	setTimeout(function(){ 
          	$(".blog-post-popup").addClass('show-popup');
          }, 1000);
      	setCookie('popup-newsletter',"news-newsletter",15);
      }
  });

$(window).resize(function(){
equalheight('body .custom-blog-pagination .blog__article .blog__infos h3');
});



  var input = document.getElementById( 'file-upload' );
  var infoArea = document.getElementById( 'file-upload-filename' );
  if(input != null){
    input.addEventListener( 'change', showFileName );
    function showFileName( event ) {  
      var input = event.srcElement;  
      var fileName = input.files[0].name;  
      infoArea.textContent = ' ' + fileName;
    }
  }


  function setCookie(name,value,days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }
  function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }




// Equal Hight 

// $(window).load(function() {
// equalheight('body .pf-bcd2eb50 .blog__article .blog__infos h3');
// });



